/** See `src/i18n/locales/en/manageSubscriptions.ts`. */
export const manageSubscriptions = {
  config: {
    title: 'Providerconfiguratie',
    lead: 'Credentials en webhook-instellingen per provider — live aan te passen, zonder deploy.',
    providerApple: 'Apple',
    providerGoogle: 'Google',
    providerMollie: 'Mollie',
    fieldLabel_issuer_id: 'Issuer ID',
    fieldLabel_key_id: 'Key ID',
    fieldLabel_p8_private_key: 'Private key (.p8)',
    fieldLabel_bundle_id: 'Bundle ID',
    fieldLabel_environment: 'Omgeving',
    fieldLabel_service_account_json: 'Service account JSON',
    fieldLabel_package_name: 'Package name',
    fieldLabel_pubsub_audience: 'Pub/Sub audience',
    fieldLabel_pubsub_service_account_email: 'Pub/Sub service account e-mail',
    fieldLabel_api_key_test: 'API-sleutel (test)',
    fieldLabel_api_key_live: 'API-sleutel (live)',
    fieldLabel_active_environment: 'Actieve omgeving',
    fieldLabel_webhook_signing_secret: 'Webhook signing secret',
    fieldLabel_redirect_url: 'Redirect-URL',
    fieldLabel_cancel_url: 'Cancel-URL',
    secretHint: 'Opgeslagen waarde: {{masked}}. Laat leeg om deze te behouden.',
    noValueYet: 'Nog niet ingesteld.',
    updatedByBefore: 'Laatst gewijzigd door',
    updatedByAfter: 'op {{when}}',
    save: 'Opslaan',
    saved: 'Configuratie opgeslagen.',
    testConnection: 'Verbinding testen',
    testResultOk: 'Verbinding OK: {{message}}',
    testResultFailed: 'Verbinding mislukt: {{message}}',
    selectPlaceholder: 'Maak een keuze…',
  },
  products: {
    title: 'Producten & providers',
    lead: 'De tier/periode/prijs-mapping per provider-product — de enige plek waar de API weet hoe lang een periode is en wat iets kost.',
    provider: 'Provider',
    tier: 'Tier',
    period: 'Periode',
    price: 'Prijs',
    active: 'Actief',
    pending: 'Gepland',
    edit: 'Bewerken',
    newProduct: 'Nieuw product',
    empty: 'Nog geen producten gemapt voor deze provider.',
    formTitle: 'Productmapping',
    formTitleNew: 'Nieuwe productmapping',
    intro:
      'Koppelt één product-id van een provider aan de betekenis ervan: welke tier, voor hoelang, tegen welke prijs. Een aankoop met een onbekend of inactief product-id wordt geweigerd. Prijswijzigingen gelden meteen na opslaan.',
    fieldProviderProductId: 'Provider-product-ID',
    fieldProviderProductIdHint_apple:
      'Exact product-id uit App Store Connect (bv. com.nolatr.sub.yearly).',
    fieldProviderProductIdHint_google: 'Exact product-/base-plan-id uit de Play Console.',
    fieldProviderProductIdHint_mollie: 'Zelfgekozen code — meestal monthly of yearly.',
    fieldTier: 'Tier',
    fieldTierHint:
      'Naam van het toegangsniveau (bv. premium). Gebruik dezelfde spelling voor elk product met dezelfde toegang.',
    durationGroupTitle: 'Looptijd',
    durationGroupHint: 'Hoelang één aankoop toegang geeft, los van wat de winkel zelf toont.',
    fieldPeriodAmount: 'Periode-aantal',
    fieldPeriodUnit: 'Periode-eenheid',
    periodUnit_day: 'Dag(en)',
    periodUnit_week: 'Week(en)',
    periodUnit_month: 'Maand(en)',
    periodUnit_year: 'Jaar/jaren',
    priceGroupTitle: 'Prijs',
    priceGroupHint_mollie:
      'Verplicht correct: dit bedrag wordt echt in rekening gebracht bij Mollie.',
    priceGroupHint_store: 'Alleen informatief — de echte prijs loopt via Apple/Google zelf.',
    fieldPriceAmount: 'Prijsbedrag',
    fieldPriceCurrency: 'Prijsvaluta',
    fieldMollieInterval: 'Mollie-interval',
    fieldMollieIntervalHint: 'Optioneel — leeg laten valt terug op 1 month / 12 months.',
    fieldActive: 'Actief',
    fieldActiveHint:
      'Uitzetten verwijdert niets: bestaande aankopen blijven zichtbaar. Nieuwe aankopen met dit product-id worden geweigerd.',
    save: 'Opslaan',
    saved: 'Product opgeslagen.',
  },
  userLedger: {
    title: 'Gebruikersoverzicht',
    lead: 'Zoek een gebruiker op om diens entitlement, aankopen en Mollie-abonnement te zien en er namens hen op te handelen.',
    searchLabel: 'Zoek gebruiker (naam of e-mail)',
    searchPlaceholder: 'Typ een naam of e-mailadres…',
    searchNoResults: 'Geen gebruikers gevonden.',
    manualEntryInstead: 'Ken je het Gebruikers-ID al? Vul het direct in.',
    searchInstead: 'Liever zoeken op naam of e-mail?',
    moveSelectedHint: 'Geselecteerd: {{name}}',
    lookupLabel: 'Gebruikers-ID',
    lookupSubmit: 'Opzoeken',
    entitlementTitle: 'Entitlement',
    active: 'Actief',
    inactive: 'Niet actief',
    tier: 'Tier',
    expiresAt: 'Verloopt',
    purchasesTitle: 'Aankopen',
    purchasesEmpty: 'Geen aankopen in deze ledger.',
    date: 'Datum',
    period: 'Periode',
    channel: 'Kanaal',
    state: 'Status',
    actions: 'Acties',
    mollieTitle: 'Mollie-abonnement',
    mollieNone: 'Geen Mollie-abonnement voor deze gebruiker.',
    mollieStatus: 'Status',
    mollieFailedPayments: 'Mislukte betalingen',
    syncStatus: 'Status synchroniseren',
    synced: 'Status gesynchroniseerd.',
    grantTitle: 'Complimentaire toegang geven',
    grantFieldTier: 'Tier',
    grantFieldAmount: 'Duur (aantal)',
    grantFieldUnit: 'Duur (eenheid)',
    grantFieldReason: 'Reden (optioneel)',
    grantSubmit: 'Toegang geven',
    granted: 'Toegang gegeven.',
    recompute: 'Herberekenen',
    recomputed: 'Entitlement herberekend.',
    cancelMollie: 'Mollie-abonnement opzeggen',
    cancelled: 'Opgezegd — toegang tot {{date}}.',
    revoke: 'Intrekken',
    revoked: 'Aankoop ingetrokken.',
    move: 'Verplaatsen',
    moveFieldToUserId: 'Bestemmings-gebruikers-ID',
    moveSubmit: 'Aankoop verplaatsen',
    moved: 'Aankoop verplaatst.',
  },
  webhooks: {
    title: 'Webhook-URL’s',
    copy: 'Kopiëren',
    copied: 'Gekopieerd.',
    key_mollie_classic: 'Mollie (classic)',
    key_mollie_next_gen: 'Mollie (next-gen)',
    key_apple_production: 'Apple (productie)',
    key_apple_sandbox: 'Apple (sandbox)',
    key_google_pubsub: 'Google (Pub/Sub)',
  },
  errors: {
    unknown_provider: 'Onbekende provider.',
    unknown_config_key: 'Een van deze velden is niet geldig voor deze provider.',
    invalid_provider: 'Onbekende provider.',
    invalid_tier: 'Deze tier is niet geldig.',
    invalid_period_amount: 'Dit duur-aantal is niet geldig.',
    invalid_period_unit: 'Deze duur-eenheid is niet geldig.',
    no_active_subscription: 'Deze gebruiker heeft geen actief Mollie-abonnement.',
    purchase_not_found: 'Deze aankoop is niet gevonden.',
    already_on_account: 'Deze aankoop staat al op dat account.',
    invalid_user: 'Die gebruiker is niet gevonden.',
    subscription_not_found: 'Dit abonnement is niet gevonden.',
    subscription_cancelled: 'Dit abonnement is al opgezegd.',
    mollie_unreachable: 'Mollie was niet bereikbaar — probeer het straks opnieuw.',
  },
} as const;
